import { Link } from "react-router-dom"
import { ForAuthersResultType } from "../../../models/news-articles/regulatory-focus/for-authors-model"

type NewsAndArticleCardTypes = {
  cardSecTitle: string
  cardSecSubTitle: string
  cardSecContent: string
  cardSecInfo: string
  article: ForAuthersResultType
}

const NewsArticleAuthorsCards = (props: NewsAndArticleCardTypes) => {
  const article = props.article
  return <div className={props.cardSecTitle}>
    <Link to={article.titleUrl}>
      <div className={props.cardSecSubTitle}>
        {article.title}
      </div>
    </Link>
    <Link to={article?.titleUrl}>
      <img src={article?.image} alt="" />
    </Link>
    <div className={props.cardSecContent}>
      <div className={props.cardSecInfo}>
        <div className="feature-content">
          <div className="feature-info">
            <ul>
              <li>
                <Link to={article.link1Url}> {article.link1Text}</Link>
              </li>
              <li>
                <Link to={article.link2Url}> {article.link2Text}</Link>
              </li>
              <li>
                <Link to={article.link3Url}> {article.link3Text}</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <Link to={article.titleUrl} className="view-more">See more</Link> */}
  </div>
}

export default NewsArticleAuthorsCards
